import React from "react";
import PropTypes from "prop-types";
import ManagePrimaryAccount from "../ManagePrimaryAccount";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userLanguage: "",
      nameSpace: "",
    };
  }
  componentDidMount() {
    let language = this.props.userLanguage.replace(/-/g, "");
    this.setState({ userLanguage: language }, () => {
      this.changeLanguage();
    });
  }

  changeLanguage = () => {
      this.setState({ nameSpace: "leftNavigationTranslation" });
    this.props.i18n.changeLanguage(this.state.userLanguage);
  };

  render() {
    return (
      <React.Fragment>
        {/* <div>
            <Title size='large' >
              Account profile
            </Title>
          </div> */}
        {/* <PrimaryContract {...this.props}/> */}
        <ManagePrimaryAccount title={this.props.t("Customer Portal - Account profile", { ns: `${this.state.nameSpace}` })} />
      </React.Fragment>
    );
  }
}

MyProfile.propTypes = {
  userLanguage: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation([
  "accountTranslation",
  "billingTranslation",
  "headerTranslation",
  "navigationTranslation",
  "loginTranslation",
  "casesTranslation",
  "leftNavigationTranslation",
])(
  connect((state) => {
    return {
      userLanguage: state.ACCOUNT.userLanguage,
    };
  })(MyProfile)
);
